module.exports = __webpack_public_path__ + "img/interior-design.10380388.png";